import { useState } from "react";
import { Buffer } from 'buffer';
import {AppSettings} from '../AppSettings'
import { TokenRefresher } from "./TokenRefreshener";

const parseErrorMessage = async (response: Response): Promise<string> => {
    try {
        const data = await response.json();
        if (Array.isArray(data?.Errors) && data.Errors.length > 0) {
            return data.Errors.join('; ');
        }
        if (typeof data?.error === 'string' && data.error) {
            return data.error;
        }
    } catch {
        // response body is missing or not JSON
    }
    return `Не удалось выполнить запрос (код ${response.status})`;
}

export const useHttp = () => {
    const [error, setError] = useState<string |null>(null);

    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        return tokenString ? JSON.parse(tokenString) : null;
    }

    const request = async (address: string, method = 'GET', body = null, headers = {'Content-Type': 'application/json'}) => {
        const url = `${AppSettings.apiBase}${address}`

        try {
            const response = await fetch(url, {method, body, headers, credentials: "include"});

            if(!response.ok) {
                throw new Error(await parseErrorMessage(response));
            }

            const data = await response.json();

            return data;

        } catch (e: any) {
            setError(e.message);
            throw e;
        }
    }

    const revokeToken = async () => {
        console.log("revokeToken")
        const url = `${AppSettings.apiBase}auth/revokeToken`;

        const response = await fetch(url, {
            method : 'POST', 
            credentials: 'include'
        });
        if(!response.ok) {
            setError("Ошибка в методе revokeToken");
        }
    } 

    const requestWithToken = async (address: string, method = 'GET', body = null, headers: Record<string, string> = {'Content-Type': 'application/json'}) => {

        //TokenRefresher.refresh().then()
        const url = `${AppSettings.apiBase}${address}`
        let token = getToken();
        headers.Authorization = 'Bearer ' + token; 

        try {
            let response = await fetch(url, {method, body, headers, credentials: "include"});

            if(response.status === 401) {
                TokenRefresher.refresh().then(res => {
                    if (res) {
                        token = getToken();
                        headers.Authorization = 'Bearer ' + token;
                        fetch(url, {method, body, headers}).then(secondRes => {
                            response = secondRes;
                        })
                    } else {
                        localStorage.removeItem("token");
                        localStorage.removeItem("role");
                        localStorage.removeItem("iconProfile");    
                        window.location.reload();
                    }
                })
            } else if(!response.ok) {
                throw new Error(await parseErrorMessage(response));
            }

            const data = await response.json();

            return data;

        } catch (e: any) {
            setError(e.message);
            throw e;
        }
    }

    const requestImage = async (address: string, method = 'GET', headers: Record<string, string> = {}) => {
        const url = `${AppSettings.apiBase}${address}`
        const token = getToken();
        headers.Authorization = 'Bearer ' + token;
            
        const response = await fetch(url, {method, headers});
        const buffer = await response.arrayBuffer();
        const data = `data:${
            response.headers.get("content-type")
        };base64,${Buffer.from(buffer).toString("base64")}`;

        return data;
    }

    const requestPdf = async (address: string, method = 'GET', headers: Record<string, string> = {}) => {
        const url = `${AppSettings.apiBase}${address}`
        const token = getToken();
        headers.Authorization = 'Bearer ' + token;
            
        const response = await fetch(url, {method, headers});

        const blob = await response.blob();

        return blob;
    }

    const clearError = () => setError(null);

    return {request, requestWithToken, requestImage, requestPdf, revokeToken, getToken, error, clearError};
}